import script from "./group.vue?vue&type=script&setup=true&lang=js"
export * from "./group.vue?vue&type=script&setup=true&lang=js"

import "./group.vue?vue&type=style&index=0&id=6af4692b&lang=less"

const __exports__ = script;

export default __exports__